import React from "react";

export default function NewUsersIcon24() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 21C18 18.8783 17.1571 16.8434 15.6569 15.3431C14.1566 13.8429 12.1217 13 10 13M10 13C7.87827 13 5.84344 13.8429 4.34315 15.3431C2.84285 16.8434 2 18.8783 2 21M10 13C13.3137 13 16 10.3137 16 7C16 3.68629 13.3137 1 10 1C6.68629 1 4 3.68629 4 7C4 10.3137 6.68629 13 10 13ZM22 20C22 16.6301 20 14 18 12.6667C18.6571 12.1268 19.1834 11.4491 19.5307 10.6841C19.8781 9.91915 20.0367 9.09046 19.9923 8.2598C19.9479 7.42914 19.7016 6.62206 19.2757 5.89919C18.8498 5.17633 18.2571 4.55926 17.5502 4.1"
        stroke="#14b8a6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
